import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const CoinIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M15.004 18.7c-1.87 0-3.454-.649-4.754-1.946-1.3-1.298-1.95-2.88-1.95-4.75S8.95 8.55 10.246 7.25c1.297-1.3 2.88-1.95 4.75-1.95s3.454.648 4.754 1.946c1.3 1.297 1.95 2.88 1.95 4.75s-.649 3.454-1.946 4.754c-1.297 1.3-2.88 1.95-4.75 1.95ZM7 18.4c-1.433-.383-2.575-1.171-3.425-2.363C2.725 14.846 2.3 13.5 2.3 12s.425-2.846 1.275-4.038C4.425 6.771 5.567 5.983 7 5.6v.75a5.81 5.81 0 0 0-2.9 2.175A5.863 5.863 0 0 0 3 12c0 1.283.367 2.441 1.1 3.475A5.81 5.81 0 0 0 7 17.65v.75Zm8-.4c1.667 0 3.083-.584 4.25-1.75C20.417 15.083 21 13.666 21 12c0-1.667-.583-3.084-1.75-4.25C18.083 6.583 16.667 6 15 6c-1.667 0-3.083.583-4.25 1.75C9.583 8.916 9 10.333 9 12c0 1.666.583 3.083 1.75 4.25C11.917 17.416 13.333 18 15 18Z"
      />
    </svg>
  </IconWrapper>
));
